import { Typography } from "@mui/material"
import React from "react"

export function NoMatch(): React.JSX.Element {
  return <Typography variant="h6">404 Not Found</Typography>
}
